var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4418 11.9085L20.5163 20.0245L11.0837 11.9755L18.0092 3.85949L18.104 3.74831L18.1064 3.75037C19.7671 1.96689 23.1126 2.25823 25.6664 4.43745C28.2203 6.61667 29.0343 9.87469 27.5342 11.7952L27.5366 11.7973L27.4418 11.9085Z",
    fill: "#178E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15815 20.0915L11.0837 11.9755L20.5163 20.0245L13.5908 28.1405L13.4959 28.2517L13.4935 28.2496C11.8328 30.0331 8.48731 29.7418 5.93348 27.5626C3.37964 25.3833 2.56565 22.1253 4.06568 20.2048L4.06328 20.2027L4.15815 20.0915Z",
    fill: "#A7DBC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9338 8.81711C19.4003 5.92639 20.0933 4.41441 23.1105 6.20025",
    stroke: "#F0EEE4",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.dbad937cbe50e82dcf706344c9951b71.svg";
export { ForwardRef as ReactComponent };